import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { clamp, modulo } from 'rev-shared/util';
import { VideoService } from 'rev-shared/media/Video.Service';
import { EmbedPlaylistService } from 'rev-shared/embed/EmbedPlaylist.Service';

import styles from './EmbedPlaylist.module.less';
import { Subscription } from 'rxjs';

@Component({
	selector: 'embed-playlist',
	templateUrl: './EmbedPlaylist.Component.html',
	host: {
		'[class]': 'styles.embedPlaylist'
	},
	standalone: false
})
export class EmbedPlaylistComponent implements OnInit, OnDestroy {
	@Input() public playlist: any;
	@Input() public params: any;
	@Input() public accountLicense: any;
	public video: any;
	public error: boolean;
	public styles = styles;
	public videoParams: any;

	private subscription: Subscription;

	constructor(
		public VideoService: VideoService,
		public EmbedPlaylistService: EmbedPlaylistService

	) {}

	public ngOnInit(): void {
		const videoId = this.playlist.videos[0].id;
		this.videoParams = this.params;
		this.selectVideo(videoId);
		this.EmbedPlaylistService.onPlaylistLoaded(this.playlist);
		this.subscription = this.EmbedPlaylistService.getSwitchVideo(this.playlist).subscribe({
			next: ({ videoId, autoplay }) => this.selectVideo(videoId, autoplay),
			error: err => console.warn('error selecting Video', err)
		});
	}

	public ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	public selectVideo(videoId?: string, autoplay?: boolean): void {
		this.error = false;

		if (!videoId) {
			console.debug('no videoId defined, not switching video');
			return;
		}

		this.VideoService.getVideoPlaybackEmbed(videoId)
			.then(video => {
				this.video = video;
				this.videoParams = {
					...this.params,
					autoplay: autoplay || this.params.autoplay
				};
			})
			.catch(e => {
				console.error('error loading video: ', e);
				this.error = true;
			});
	}

	public previous(): void {
		this.move(-1);
	}

	public next(): void {
		this.move(1);
	}

	private move(offset: number): void {
		const i = clamp(this.playlist.videos.findIndex(v => v.id === this.video?.id), 0);
		const index = modulo(i + offset, this.playlist.videos.length);
		const video = this.playlist.videos[index];

		if(video) {
			this.selectVideo(video.id, true);
		}
	}
}

@Component({
	selector: 'embed-playlist-slider',
	templateUrl: './EmbedPlaylistSlider.Component.html',
	standalone: false
})
export class EmbedPlaylistSliderComponent extends EmbedPlaylistComponent implements OnInit {

	public toolbarVisible: boolean;

	constructor(
		VideoService: VideoService,
		EmbedPlaylistService: EmbedPlaylistService
	) {
		super(VideoService, EmbedPlaylistService);
	}

	public ngOnInit(): void {
		this.toolbarVisible = !this.params.noToolbar;
		super.ngOnInit();
	}
}


